<template>
  <div>
    <a-modal
      title="确认服务节点"
      v-model="isShow"
      ok-text="提交"
      centered
      :width="1400"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <div style="color: red">提示：每次修改后，点击“提交”按钮，才会保存修改信息！注意，“奠盒仪式”服务适用于订单金额不低于13600元的订单。</div>
      <a-table
        :scroll="{ x: 'max-content', y: 350 }"
        :columns="nodeColumns"
        :data-source="nodes"
        :loading="loading"
        :pagination="false"
        row-key="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <div slot="date" slot-scope="date,record">
          <a-range-picker
            :show-time="{ format: 'HH:mm' }"
            :placeholder="['开始时间', '结束时间']"
            format="YYYY-MM-DD HH:mm"
            style="width: 340px;"
            :value="record.date"
            @change="(val) => handleChangeDate(val, record)"
          />
          <div class="error-message">
            {{ record.error }}
          </div>
        </div>

        <div slot="remark" slot-scope="remark,record">
          <a-input
            style="width: 150px;"
            :max-length="20"
            v-model:value="record.remark"
            placeholder="请输入备注"
          />
        </div>

        <span slot="actions" slot-scope="text, record, index">
          <a-space>
            <a @click="up(index)">上移</a>
            <a @click="down(index)">下移</a>
          </a-space>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { findServiceOrderConfirmNodeForm, confirmServiceNodes } from '@/api/order'
import calendarConverter from 'js-calendar-converter'
import { formatRangeBeginDateTime, formatRangeEndDateTime } from '@/utils/time'

export default {
  name: 'ConfirmServiceNode',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      submitting: false,
      nodes: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    nodeColumns() {
      return [
        {
          title: '服务节点',
          dataIndex: 'name',
          width: 100
        },
        {
          title: '日期',
          dataIndex: 'date',
          width: 380,
          scopedSlots: { customRender: 'date' }
        },
        {
          title: '农历',
          dataIndex: 'lunar',
          width: 150,
          scopedSlots: { customRender: 'lunar' }
        },
        {
          title: '星期',
          dataIndex: 'week',
          width: 150,
          scopedSlots: { customRender: 'week' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 180,
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    fetchFormData() {
      this.loading = true
      findServiceOrderConfirmNodeForm(this.serviceOrderId).then((res) => {
        if (res.code === 0) {
          const nodes = res.data
          for (const node of nodes) {
            if (node.date && node.date.length > 0) {
              const beginAt = this.$moment(node.date[0], 'YYYY-MM-DD HH:mm')
              const endAt = this.$moment(node.date[1], 'YYYY-MM-DD HH:mm')
              node.date = [beginAt, endAt]
              const lunar1 = this.fetchLunarDate(beginAt)
              const lunar2 = this.fetchLunarDate(endAt)
              if (lunar1 === lunar2) {
                node.lunar = lunar1
              } else {
                node.lunar = lunar1 + '~' + lunar2
              }
              const week1 = this.fetchLunarWeek(beginAt)
              const week2 = this.fetchLunarWeek(endAt)
              if (week1 === week2) {
                node.week = week1
              } else {
                node.week = week1 + '~' + week2
              }
            }
            this.nodes.push(node)

            if (node.is_selected) {
              this.selectedRowKeys.push(node.id)
              this.selectedRows.push(node)
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },

    handleChangeDate(value, record) {
      record.error = '请选择日期'
      record.date = value
      if (value && value.length > 0) {
        const lunar1 = this.fetchLunarDate(value[0])
        const lunar2 = this.fetchLunarDate(value[1])
        if (lunar1 === lunar2) {
          record.lunar = lunar1
        } else {
          record.lunar = lunar1 + '~' + lunar2
        }

        const week1 = this.fetchLunarWeek(value[0])
        const week2 = this.fetchLunarWeek(value[1])
        if (week1 === week2) {
          record.week = week1
        } else {
          record.week = week1 + '~' + week2
        }
        record.error = ''
      } else {
        record.lunar = ''
        record.week = ''
      }
      this.nodes = [...this.nodes]
    },

    calendarLunar(date) {
      if (!date) {
        return ''
      }
      return calendarConverter.solar2lunar(date.year(), date.month() + 1, date.date())
    },

    fetchLunarDate(date) {
      const lunar = this.calendarLunar(date)
      return lunar.gzYear + '年' + lunar.IMonthCn + lunar.IDayCn
    },

    fetchLunarWeek(date) {
      const lunar = this.calendarLunar(date)
      return lunar.ncWeek
    },

    up(index) {
      if (index === 0) {
        this.$warning({
          title: '已置顶无法上移',
          content: ''
        })
        return
      }

      const obj = this.nodes[index]
      const lastObj = this.nodes[index - 1]
      this.$set(this.nodes, index - 1, obj)
      this.$set(this.nodes, index, lastObj)
    },

    down(index) {
      if (index === this.nodes.length - 1) {
        this.$warning({
          title: '已置底无法下移',
          content: ''
        })
        return
      }
      const obj = this.nodes[index]
      const nextObj = this.nodes[index + 1]
      this.$set(this.nodes, index + 1, obj)
      this.$set(this.nodes, index, nextObj)
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
      }

      const reqNodes = []
      let hasError = false
      for (const node of this.selectedRows) {
        this.handleChangeDate(node.date, node)
        if (node.error) {
          hasError = true
        }
      }
      if (hasError) {
        return
      }

      for (const node of this.nodes) {
        if (this.selectedRowKeys.includes(node.id)) {
          reqNodes.push({
            ...node,
            begin_at: formatRangeBeginDateTime(node.date),
            end_at: formatRangeEndDateTime(node.date)
          })
        }
      }

      this.submitting = true
      confirmServiceNodes(this.serviceOrderId, { nodes: reqNodes }).then((res) => {
        if (res.code === 0) {
          // 关闭模态框
          this.isShow = false
          // 告知父组件已完成
          this.$emit('completed')
        }
        this.submitting = false
      })
    }
  }

}
</script>

<style lang="less" scoped>
.error-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}
</style>

